document.addEventListener('DOMContentLoaded', function () {

  const mq = window.matchMedia('(min-width: 769px)');

  function initAdaptiveVideos() {
    const isDesktop = mq.matches;

    const targetSelector = isDesktop ? '.video-desktop' : '.video-mobile';
    const cleanSelector  = isDesktop ? '.video-mobile'  : '.video-desktop';

    // Limpiar los que no corresponden
    document.querySelectorAll(cleanSelector).forEach(container => {
      const video = container.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      container.innerHTML = '';
      container.dataset.loaded = 'false';
    });

    // Insertar los correctos
    document.querySelectorAll(targetSelector).forEach(container => {
      if (container.dataset.loaded === 'true') return;

      const webm = container.dataset.webm;
      const mp4  = container.dataset.mp4;
      if (!webm && !mp4) return;

      const video = document.createElement('video');
      video.playsInline = true;
      video.muted = true;
      video.loop = container.dataset.loop === 'true';
      video.autoplay = container.dataset.autoplay === 'true';

      video.style.width = '100%';
      video.style.height = '100%';
      video.style.objectFit = 'cover';

      if (webm) {
        const s = document.createElement('source');
        s.src = webm;
        s.type = 'video/webm';
        video.appendChild(s);
      }

      if (mp4) {
        const s = document.createElement('source');
        s.src = mp4;
        s.type = 'video/mp4';
        video.appendChild(s);
      }

      container.appendChild(video);
      container.dataset.loaded = 'true';

      if (video.autoplay) {
        video.load();
        video.play().catch(() => {});
      }
    });
  }

  initAdaptiveVideos();

  if (mq.addEventListener) {
    mq.addEventListener('change', initAdaptiveVideos);
  } else {
    mq.addListener(initAdaptiveVideos);
  }
});